// extracted by mini-css-extract-plugin
module.exports = {"button":"cd01fbf7b5--button--1iTOq"};